import React from 'react';

import './PlayIcon.scss';
interface IPlayIconProps {
  color?: string;
}
const PlayIcon = ({ color = '#fff' }: IPlayIconProps) => {
  return (
    <svg
      className="icon icon-play"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 24 24"
      style={{ borderColor: color, fill: color }}
    >
      <path d="M8 5v14l11-7z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

export default PlayIcon;
